import { useActiveRoomStore } from '../atoms/map-active-room';

export const useActiveRoom = () => useActiveRoomStore((state) => state.activeRoom);

export const useSetActiveRoom = () => useActiveRoomStore((state) => state.setActiveRoom);

export const useClearActiveRoom = () => useActiveRoomStore((state) => state.clearActiveRoom);

export const useActiveRoomActions = () => ({
    setActiveRoom: useActiveRoomStore((state) => state.setActiveRoom),
    clearActiveRoom: useActiveRoomStore((state) => state.clearActiveRoom),
});
